import { useNavigation } from '@react-navigation/native'
import React from 'react'
import { StyleSheet } from 'react-native'

import { links } from 'utils/constants'

import { useCoachOnboardingModal } from 'contexts/CoachOnboardingModalContext'

import { Box } from '../Box'
import { Button } from '../Button'
import { Text } from '../Text'

const styles = StyleSheet.create({
  createButton: {
    marginRight: 8,
  },
})

export const NoCoaches = ({ headerText, bodyText }: { headerText: string; bodyText: string }) => {
  const navigation = useNavigation()
  const coachOnboardingModalRef = useCoachOnboardingModal()

  return (
    <>
      <Text testID='NoCoachesHeader' align='center' fontSize='md' color='greyDarkest' bold>
        {headerText}
      </Text>
      <Text testID='NoCoachesText' align='center' fontSize='sm' color='greyDark'>
        {bodyText}
      </Text>
      <Box
        testID='NoCoachesButtonRow'
        flexDirection='row'
        align='center'
        justifyContent='center'
        margin={{ vertical: 'md' }}
      >
        <Button
          testID='CreateButton'
          type='v2secondary'
          borderRadius='sm'
          padding={{ vertical: 'sm', horizontal: 'md' }}
          style={styles.createButton}
          onPress={() => coachOnboardingModalRef?.current.present()}
        >
          <Text color='white' fontSize='sm'>
            Create
          </Text>
        </Button>
        <Button
          testID='JoinButton'
          type='v2secondary'
          borderRadius='sm'
          padding={{ vertical: 'sm', horizontal: 'md' }}
          onPress={() => navigation.navigate(links.HOME_STACK, { screen: links.TRAINERS_PAGE })}
        >
          <Text color='white' fontSize='sm'>
            Join
          </Text>
        </Button>
      </Box>
    </>
  )
}
